var normalizeVideoAnalyticsEventDuration = function normalizeVideoAnalyticsEventDuration(duration) {
  if (duration < 0) {
    return 0;
  }
  if (duration >= 11) {
    return 10;
  }
  return duration;
};
export default normalizeVideoAnalyticsEventDuration;